import { render, staticRenderFns } from "./EDIPreview.vue?vue&type=template&id=c5e36be6&scoped=true"
import script from "./EDIPreview.vue?vue&type=script&lang=js"
export * from "./EDIPreview.vue?vue&type=script&lang=js"
import style0 from "./EDIPreview.vue?vue&type=style&index=0&id=c5e36be6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c5e36be6",
  null
  
)

export default component.exports